import { SpriteItem } from './types'

export const spriteData: SpriteItem[] = [
  {
    class: 'bird',
    x: 271,
    y: 320,
    w: 79,
    h: 83,
    speed: 1,
    top: 400,
    left: 1160,
    dx: -20,
    dy: -200,
  },
  {
    class: 'blue-square',
    x: 228,
    y: 10,
    w: 235,
    h: 236,
    speed: 3,
    top: 125,
    left: 1620,
    dx: -50,
    dy: -400,
  },
  {
    class: 'cat',
    x: 159,
    y: 320,
    w: 92,
    h: 126,
    speed: 1.5,
    axis: 'x',
    top: 560,
    left: 1605,
    dx: 0,
    dy: -200,
  },
  {
    class: 'cross',
    x: 656,
    y: 10,
    w: 69,
    h: 88,
    speed: 1,
    top: 235,
    left: 1130,
    dx: 30,
    dy: -100,
  },
  {
    class: 'cup',
    x: 10,
    y: 470,
    w: 74,
    h: 84,
    speed: 1,
    top: 370,
    left: 1595,
    dx: -20,
    dy: -100,
  },
  {
    class: 'left-bug',
    x: 370,
    y: 320,
    w: 82,
    h: 66,
    speed: 1,
    top: 580,
    left: 1170,
    dx: -160,
    dy: -100,
  },
  {
    class: 'pink-square',
    x: 483,
    y: 10,
    w: 153,
    h: 153,
    speed: 2,
    axis: 'y',
    top: 630,
    left: 1120,
    dx: -50,
    dy: -200,
  },
  {
    class: 'right-bug',
    x: 483,
    y: 183,
    w: 96,
    h: 74,
    speed: 1,
    top: 285,
    left: 1530,
    dx: -100,
    dy: -100,
  },
  {
    class: 'right-stat',
    x: 10,
    y: 10,
    w: 198,
    h: 290,
    speed: 3,
    top: 475,
    left: 1665,
    dx: -50,
    dy: -300,
  },
  {
    class: 'rose-square',
    x: 10,
    y: 320,
    w: 129,
    h: 130,
    speed: 2,
    axis: 'xy',
    top: 135,
    left: 970,
    dx: -15,
    dy: -200,
  },
  {
    class: 'top-stat',
    x: 656,
    y: 118,
    w: 56,
    h: 73,
    speed: 1,
    top: 140,
    left: 1470,
    dx: 125,
    dy: -100,
  },
]
